import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FileResultRequestBody, FileResultResponse } from "./types";

export class FileResultAPI extends BaseAPI<
  FileResultRequestBody,
  FileResultResponse
> {
  protected route = ApiRoutes.file.result;
  protected method = RequestMethod.GET;
  protected params = [
    "mode",
    "upload_result_id",
    "file_name",
    "user_id",
    "menu_id",
    "template_id",
    "date_from",
    "date_to",
    "result",
    "sort_key",
    "sort_order",
    "page",
    "size",
  ];
}
